import React, { useCallback } from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { StoreState } from '../../store/createStore';
import { useToast } from '../../hooks/toast';
import { routesEndpoints } from '../../routes/endpoint';
import {
  NavMobile,
  LiNav,
  ContainerMobile,
  ContainerBtns,
  Button,
  BadgeNumber,
} from './styles';
import { config } from '../../config';
import {
  openMenuBase,
} from '../../store/modules/parameter/actions';
import { FiUser, FiHeart, FiShoppingCart, FiList } from 'react-icons/fi';
import Loading from '../Loading';

interface NavLinkProps {
  bMobile?: boolean;
}

export function NavLink({ bMobile = false }: NavLinkProps) {
  const { onTranslation: t } = useTranslation();
  const history = useHistory();
  const {
    user: { favorite },
    isSignedIn,
  } = useSelector((state: StoreState) => state.auth);
  const { checkout, loading: loadingCheckout } = useSelector(
    (state: StoreState) => state.checkout,
  );
  const { onSetMessage } = useToast();
  const dispatch = useDispatch();

  const handledRouterPage = useCallback(
    (type: string) => {
      if (loadingCheckout) return;
      if (!isSignedIn && type !== routesEndpoints.HOME) {
        onSetMessage({
          type: 'error',
          description: t('main.messages_toast.login'),
        });
        return;
      }

      history.push(type);
      if (bMobile) dispatch(openMenuBase());
    },
    [history, isSignedIn, onSetMessage, t, dispatch, bMobile, loadingCheckout],
  );

  if (bMobile) {
    return (
      <ContainerMobile>
        <img src={config.logo} alt="ConectoGO" width={120} />
        <NavMobile>
          <LiNav
            id="button-action-home"
            bLink
            onClick={() => handledRouterPage(routesEndpoints.HOME)}
          >
            Inicio
          </LiNav>
          <LiNav>
            Minha conta
            <ul>
              <LiNav
                id="button-action-account"
                bLink
                onClick={() =>
                  handledRouterPage(routesEndpoints.NEW_ACCOUNT)
                }
              >
                Meus dados
              </LiNav>
              <LiNav
                id="button-action-method"
                bLink
                onClick={() =>
                  handledRouterPage(routesEndpoints.NEW_ACCOUNT_PAYMENT)
                }
              >
                Meus cartões
              </LiNav>
              <LiNav
                id="button-action-address"
                bLink
                onClick={() =>
                  handledRouterPage(routesEndpoints.NEW_ACCOUNT_ADDRESS)
                }
              >
                Meus endereços
              </LiNav>
              <LiNav
                id="button-action-order"
                bLink
                onClick={() =>
                  handledRouterPage(routesEndpoints.NEW_ACCOUNT_ORDERS)
                }
              >
                Meus pedidos
              </LiNav>
              <LiNav
                id="button-action-cancel-account"
                bLink
                onClick={() =>
                  handledRouterPage(routesEndpoints.NEW_ACCOUNT_CANCEL)
                }
              >
                Cancelar conta
              </LiNav>
            </ul>
          </LiNav>
          <LiNav
            id="button-action-favorite"
            bLink
            onClick={() =>
              handledRouterPage(routesEndpoints.ACCOUNT_FAVORITE)
            }
          >
            Favoritos
          </LiNav>
          <LiNav
            id="button-action-checkout"
            bLink
            onClick={() => handledRouterPage(routesEndpoints.NEW_CHECKOUT)}
          >
            Carrinho
          </LiNav>
        </NavMobile>
      </ContainerMobile>
    );
  }

  return (
    <ContainerBtns>
      <Button
        id="button-action-myaccount"
        onClick={() => handledRouterPage(routesEndpoints.NEW_ACCOUNT)}
        style={{ cursor: 'pointer' }}
        bHidden
      >
        <FiUser />
        <span>{t('main.search.my_account')}</span>
      </Button>
      <Button
        id="button-action-favorite"
        onClick={() => handledRouterPage(routesEndpoints.ACCOUNT_FAVORITE)}
        bHidden
      >
        {favorite && favorite.length > 0 && (
          <BadgeNumber
            number={favorite?.length || favorite?.length}
            isLoading={false}
          >
            <span>{favorite && favorite.length}</span>
          </BadgeNumber>
        )}
        <FiHeart />
        <span>{t('main.search.my_bookmarks')}</span>
      </Button>
      <Button
        id="button-action-checkout"
        onClick={() => handledRouterPage(routesEndpoints.NEW_CHECKOUT)}
      >
        {checkout.items_count > 0 && (
          <BadgeNumber
            number={checkout.items_count}
            isLoading={loadingCheckout}
          >
            {loadingCheckout ? (
              <Loading size={15} />
            ) : (
              <span id="item-checkout-qtd">{checkout.items_count}</span>
            )}
          </BadgeNumber>
        )}
        <FiShoppingCart />
        <span>{t('main.search.my_request')}</span>
      </Button>
      {/* <Button onClick={() => handledRouterPage(routesEndpoints.NEW_CHECKOUT,0)}>
            <span>{t('main.search.cart_amout')}</span>
            {
              loadingCheckout ? (
                <Loading size={20} />
              ) : (
                <CartTotal>
                  <span> {Number(checkout.grand_total).toFixed(2)}</span>
                </CartTotal>
              )
            }
          </Button> */}
      <Button 
        id="button-action-order" 
        onClick={() => handledRouterPage(routesEndpoints.NEW_ACCOUNT_ORDERS)}>
        <FiList />
        <span>{t('main.search.cart_amout')}</span>
      </Button>
    </ContainerBtns>
  );
}
